import { Card, Grid, Typography, Box, IconButton, Chip } from '@mui/material';
import React from 'react';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import routes from '../../../../Utils/routes';
import { IEventCards } from '../../../../interfaces/Profile';
import numberToWords from 'number-to-words';

const EventsCard: React.FunctionComponent<IEventCards> = (props) => {
  const { eventTitle, endTime, startDate, startTime, endDate, Id } = props;
  const navigate = useNavigate();
  const duration = moment(endDate).diff(startDate, 'days');

  return (
    <div>
      <Card style={{ backgroundColor: '#F6F8FB', padding: 20, borderRadius: 10, boxShadow: 'none' }}>
        <Typography style={{ textAlign: 'left', fontWeight: 500, fontSize: '12px' }}>{eventTitle || '-'}</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1 }}>
          <Chip
            label={`${numberToWords.toWords(duration)} - day`}
            size="small"
            sx={{
              backgroundColor: '#BFCEFF',
              color: '#1A358C',
              fontSize: '10.5px',
              textTransform: 'capitalize',
              fontWeight: '500',
            }}
          />
        </Box>
        {/* <Typography
          sx={{ textTransform: 'capitalize', backgroundColor: '#BFCEFF', color: '#1A358C', padding: 0.5, fontSize: '10.5px', borderRadius: 5, fontWeight: 500, width: 80, mt: 2 }}
        >{`${numberToWords.toWords(duration)} - day`}</Typography> */}
        <Box sx={{ display: 'flex', justifyContent: 'start', mt: 3 }}>
          <AccessTimeIcon fontSize="small" sx={{ fontSize: '15px' }} />{' '}
          <Typography fontWeight={'500'} fontSize={'10px'} sx={{ ml: 1 }}>
            {moment(startDate).format('DD MMM, YY')}, {moment(startTime).format('h: mmA')} - {moment(endTime).format('h: mmA')} IST
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={10} sm={10} md={10} lg={10} xl={10}>
            <Box sx={{ display: 'flex', justifyContent: 'start', mt: 1.5 }}>
              <LocationOnOutlinedIcon fontSize="small" sx={{ fontSize: '15px' }} />{' '}
              <Typography fontWeight={'500'} fontSize={'10px'} sx={{ ml: 1 }}>
                Bangalore, India
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2} style={{ display: 'flex', justifyContent: 'end' }}>
            <IconButton
              onClick={() => {
                navigate(`/events/${Id}`);
              }}
            >
              <ArrowForwardOutlinedIcon style={{ marginTop: 5, fontSize: '15px' }} />
            </IconButton>
          </Grid>
        </Grid>
      </Card>
    </div>
  );
};

export default EventsCard;
